/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { service } from "@ember/service";
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import type { Section } from "parog-web/models/ctcae-filled-journal-event";
import type SemeiaSessionService from "parog-web/services/session";

interface Signature {
  Args: {
    key: string;
    sections: Section[];
  };
}
export default class extends Component<Signature> {
  @tracked isOpen = true;
  @service declare session: SemeiaSessionService;

  get title(): string {
    return this.args.sections[0].title;
  }
}
